export default "__VITE_ASSET__BVR$GmYm6bDnhROMEfYMBw__";